'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
var React = _interopDefault(require('react'));
var Select = require('react-select');
var Select__default = _interopDefault(Select);
var componentsButton = require('@keytrade/components-button');
var componentsLabel = require('@keytrade/components-label');
var componentsVisuallyhidden = require('@keytrade/components-visuallyhidden');
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _objectDestructuringEmpty(t) {
  if (null == t) throw new TypeError("Cannot destructure " + t);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
var colors = functions.config.colors.list;
var fontSize = functions.config.fontSizes.desktop;
var getFont = functions.config.fonts.getFont;
var InputHeightChooser = function InputHeightChooser(_ref) {
  var theme = _ref.theme;
  if (theme.type === 'secure') return '3.2rem';
  if (theme.type === 'small') return '2.6rem';
  return '4.2rem';
};
var SelectInputWrapper = styled.div.withConfig({
  displayName: "SelectInputWrapper",
  componentId: "sc-119fpri-0"
})(["", "}margin:", ";max-width:100%;width:", ";font-size:", ";font-family:", ";", " .PrefixSelectDropdown{&__control{position:relative;", " min-height:auto;flex-wrap:nowrap;background:", ";border-top-left-radius:", ";border-top-right-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";", " border-width:.1rem;border-color:", ";cursor:pointer;box-shadow:none;", " .PrefixSelectDropdown__value-container--has-value .PrefixSelectDropdown__menu-listItem{padding-right:0;white-space:nowrap;", "}&:hover{border-color:", ";box-shadow:0 0 .4rem 0 ", ";}&:last-of-type{.PrefixSelectDropdown__indicator{transform:rotate(0deg);}}&-is-focused{border-color:", ";&:hover{border-color:", ";}+ div .PrefixSelectDropdown__menu{border:.1rem solid ", ";border-top-color:", ";}}}&__placeholder{margin-left:1.3rem;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:calc(100% - 1.3rem);color:", ";}&__indicator{padding:0 .8rem;svg{fill:", ";}&-separator:first-child{display:none;}}&__menu{", " z-index:2500;background:", ";margin:0;border-top-left-radius:0;border-top-right-radius:0;border:.1rem solid ", ";top:calc(100% - .1rem);box-shadow:0 .2rem 0.2rem 0 ", ";&-list{padding:0;margin:0;}}&__option{padding:0;cursor:pointer;background-color:", ";color:", ";&:active{background-color:", "}&--is-focused{*{background-color:", ";color:", " !important;}}}&__value-container{padding:0;position:relative;overflow:hidden;text-overflow:ellipsis;min-height:", ";input{margin-left:1.1rem;", " position:absolute;}}&__value-container--is-multi{padding:.2rem .8rem;input{margin-left:0;}}&__input{position:absolute;top:", ";left:", ";vertical-align:bottom;", "}&__multi-value{background-color:", ";border-radius:.3rem;}&__clear-indicator{fill:", ";}&__multi-value__label{padding:.1rem .1rem .1rem .6rem;color:", ";}&__multi-value__remove{color:", ";background-color:transparent;&:hover{color:", ";background-color:", ";}}&__value-container--has-value{color:", ";display:flex;font-family:", ";flex-wrap:nowrap;}&__menu-listItem{max-width:100%;overflow:hidden;text-overflow:ellipsis;line-height:normal;}&__--is-disabled{cursor:not-allowed;}&__control--is-disabled{background-color:", " !important;border:.1rem solid ", " !important;cursor:not-allowed !important;&:hover{cursor:not-allowed !important;}&&,*,.PrefixSelectDropdown__value-container > div:first-child *{color:", " !important;}.PrefixSelectDropdown__indicator svg,.PrefixSelectDropdown__indicator svg *{fill:", " !important;}}&__menu{border-radius:0 0 .5rem .5rem;}&__control--menu-is-open{border-bottom-left-radius:0;border-bottom-right-radius:0;}&__menu-list{border-radius:0 0 .3rem .3rem;}&__group{padding:0;}&__group-heading{margin:0;padding:", ";font-size:", ";font-family:", ";background-color:", ";color:", ";text-transform:none;}}"], function (props) {
  return props.theme.dark ? " \n    &, .PrefixSelectDropdown__control,. PrefixSelectDropdown__control--is-focused{\n\n      &:focus, &:focus-visible, &.focus-visible, .focus-visible, :focus, :focus-visible {\n        box-shadow: rgba(0 179 219 / 26%) 0 0 0.4rem 0 !important;\n        border:1px solid ".concat(colors.BlueHeaven, " !important;\n        border-radius: 4px !important;\n        outline: none !important;\n      \n    }") : "  \n      &:focus, &:focus-visible, &.focus-visible, .focus-visible, :focus, :focus-visible  {\n        box-shadow: rgba(167 189 204 / 50%) 0 0 0.4rem 0 !important;\n        border:1px solid ".concat(colors.BlueDawn, " !important;\n        border-radius: 4px !important;\n        outline: none !important;\n      \n    }");
}, function (props) {
  return props.margin;
}, function (props) {
  return !props.append && !props.prepend ? '100%' : 'auto';
}, function (props) {
  return props.theme && (props.theme.type === 'secure' || props.theme.type === 'small') ? fontSize.sm : fontSize.md;
}, function (props) {
  return getFont(props.theme, props.theme && (props.theme.type === 'secure' || props.theme.type === 'small') ? 'regular' : 'semiBold');
}, function (props) {
  return props.disabled ? 'cursor: not-allowed;' : null;
}, function (props) {
  return props.append && 'left: -.1rem;';
}, function (props) {
  return props.disabled ? colors.GreyWhite : props.theme.dark ? colors.BlueMoon : colors.White;
}, function (props) {
  return props.append ? '0' : '.3rem';
}, function (props) {
  return props.prepend ? '0' : '.3rem';
}, function (props) {
  return props.prepend ? '0' : '.3rem';
}, function (props) {
  return props.append ? '0' : '.3rem';
}, function (props) {
  return props.focused && 'z-index: 1;';
}, function (props) {
  return props.theme.dark ? colors.GreyBlue : colors.GreyLight;
}, function (props) {
  return props.error && "\n        border: .1rem solid ".concat(colors.Tomato, " !important;\n      ");
}, function (props) {
  return props.hasComponents && 'position: relative;';
}, function (props) {
  return props.theme.dark ? colors.GreyBlue : props.focused ? colors.BlueCloudy : colors.GreyLight;
}, colors.BlueCloudyTransparent, function (props) {
  return props.theme.dark ? colors.GreyBlue : colors.BlueCloudy;
}, function (props) {
  return props.theme.dark ? colors.GreyBlue : colors.BlueCloudy;
}, function (props) {
  return props.theme.dark ? colors.GreyBlue : colors.BlueCloudy;
}, colors.GreyLight, function (props) {
  return props.theme.dark ? colors.BlueCloudy : colors.GreyWarm;
}, colors.BlueSky, function (props) {
  return props.append && 'left: -.1rem;';
}, function (props) {
  return props.theme.dark ? colors.BlueMoon : colors.White;
}, function (props) {
  return props.theme.dark ? colors.GreyBlue : colors.GreyLight;
}, colors.BlueCloudyTransparent, function (props) {
  return props.disabled ? colors.GreyWhite : props.theme.dark ? colors.BlueMoon : colors.White;
}, function (props) {
  return props.disabled ? colors.GreyWarm : props.theme.dark ? colors.White : colors.BlueDark;
}, function (props) {
  return props.theme.dark ? colors.BlueNight : colors.BlueSky;
}, function (props) {
  return props.theme.dark ? colors.BlueDawn : colors.BlueSky;
}, colors.White, function (props) {
  return props.small ? '2.6rem' : InputHeightChooser;
}, function (props) {
  return !props.isSearchable && 'height: 0;';
}, function (props) {
  return props.theme && props.theme.type === 'secure' ? '.8rem' : props.theme && props.theme.type === 'small' ? '.6rem' : '1.3rem';
}, function (props) {
  return props.theme && props.theme.type === 'secure' ? '-.3rem' : props.theme && props.theme.type === 'small' ? '-.5rem' : '.2rem';
}, function (props) {
  return props.theme.dark ? " \n          &:focus, &:focus-visible, &.focus-visible {\n            box-shadow: rgba(0 179 219 / 26%) 0 0 0.4rem 0;\n            border:1px solid ".concat(colors.BlueHeaven, ";\n            border-radius: 4px;\n            outline: none;\n          \n        }") : "  \n          &:focus, &:focus-visible, &.focus-visible {\n            box-shadow: rgba(167 189 204 / 50%) 0 0 0.4rem 0;\n            border:1px solid ".concat(colors.BlueDawn, ";\n            border-radius: 4px;\n            outline: none;\n          \n        }");
}, function (props) {
  return props.theme.dark ? colors.GreyWarm : colors.GreyWhite;
}, function (props) {
  return props.theme.dark ? colors.White : colors.BlueDark;
}, function (props) {
  return props.theme.dark ? colors.White : colors.BlueDark;
}, function (props) {
  return props.theme.dark ? colors.White : colors.BlueDark;
}, function (props) {
  return props.theme.dark ? colors.White : colors.BlueDark;
}, function (props) {
  return props.theme.dark ? colors.GreyWarm : colors.GreyLight;
}, function (props) {
  return props.theme.dark ? colors.White : colors.BlueDark;
}, function (props) {
  return getFont(props.theme, 'semiBold');
}, colors.GreyWhite, colors.GreyLight, colors.GreyWarm, colors.GreyWarm, function (props) {
  return props.theme && props.theme.type === 'secure' ? '.8rem' : props.theme && props.theme.type === 'small' ? '.5rem' : '1.2rem';
}, function (props) {
  return props.theme.type === 'secure' || props.theme.type === 'small' ? fontSize.sm : fontSize.md;
}, function (_ref2) {
  var theme = _ref2.theme;
  return getFont(theme, 'semiBold');
}, colors.GreyWhite, function (props) {
  return props.theme.dark ? colors.White : colors.BlueDark;
});
var getFont$1 = functions.config.fonts.getFont;
var fontSize$1 = functions.config.fontSizes.desktop;
var SelectDropdownOption = function SelectDropdownOption(_ref) {
  var data = _ref.data,
    type = _ref.type,
    dropdownID = _ref.dropdownID;
  return /*#__PURE__*/React.createElement(Option, {
    className: "PrefixSelectDropdown__menu-listItem",
    data: data,
    id: "".concat(dropdownID, "-").concat(data.value)
  },
  // This is pretty hacky. We are checking the "type" prop which is normally used to identify if the item is an option or a group header.
  // But "type" has another specificity : it's not present when the option is displayed as the currently selected item. This way, we can display a different label when selected.
  !type && data.labelSelected ? data.labelSelected : data.label);
};
var Option = styled.div.withConfig({
  displayName: "SelectDropdownOption__Option",
  componentId: "sc-1v4427h-0"
})(["padding:", ";font-size:", ";font-family:", ";"], function (props) {
  return props.theme && props.theme.type === 'secure' ? '.8rem .7rem .7rem' : props.theme && props.theme.type === 'small' ? '.6rem .5rem .5rem' : '1.2rem 1.1rem 1.1rem';
}, function (props) {
  return props.theme.type === 'secure' || props.theme.type === 'small' ? fontSize$1.sm : fontSize$1.md;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.type === 'secure' || theme.type === 'small' ? getFont$1(theme, 'regular') : getFont$1(theme, 'semiBold');
});
var Option$1 = Select.components.Option;
var SelectDropdownOptionWrapper = function SelectDropdownOptionWrapper(props) {
  return /*#__PURE__*/React.createElement(Option$1, props, /*#__PURE__*/React.createElement(SelectDropdownOption, props));
};
var colors$1 = functions.config.colors.list;
var IcnArrowDown = function IcnArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.4rem",
    height: "2.4rem",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M11.296 14.998L5.45 9.108a.597.597 0 0 1 0-.85l.358-.355a.609.609 0 0 1 .856 0l5.06 5.115 5.058-5.11a.609.609 0 0 1 .857 0l.357.355a.597.597 0 0 1 0 .85l-5.845 5.89a.613.613 0 0 1-.856-.005z"
  }));
};
var IcnArrowUp = function IcnArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.4rem",
    height: "2.4rem",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.998 12.152l-5.89 5.845a.597.597 0 0 1-.85 0l-.355-.357a.609.609 0 0 1 0-.857l5.115-5.059-5.11-5.059a.609.609 0 0 1 0-.856l.355-.358a.597.597 0 0 1 .85 0l5.89 5.845c.23.237.23.62-.005.856z",
    fill: props.color,
    fillRule: "evenodd",
    transform: "rotate(-90 12.45 11.724)"
  }));
};
var IcnCrossInput = function IcnCrossInput() {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.4rem",
    height: "2.4rem",
    viewBox: "0 0 24 24",
    class: "PrefixSelectDropdown__clear-indicator"
  }, /*#__PURE__*/React.createElement("title", null, "Cross"), /*#__PURE__*/React.createElement("path", {
    fill: colors$1.BlueSky,
    fillRule: "evenodd",
    d: "M13.9 12.25l5.42-5.42a.5.5 0 0 0 0-.71l-.94-.94a.5.5 0 0 0-.71 0l-5.42 5.42-5.42-5.42a.5.5 0 0 0-.71 0l-.94.94a.5.5 0 0 0 0 .71l5.42 5.42-5.42 5.42a.5.5 0 0 0 0 .71l.94.94a.5.5 0 0 0 .71 0l5.42-5.42 5.42 5.42a.5.5 0 0 0 .71 0l.94-.94a.5.5 0 0 0 0-.71l-5.42-5.42z"
  }));
};
var IcnCrossValue = function IcnCrossValue() {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.2rem",
    height: "1.2rem",
    viewBox: "0 0 24 24",
    class: "PrefixSelectDropdown__clear-indicator"
  }, /*#__PURE__*/React.createElement("title", null, "Cross"), /*#__PURE__*/React.createElement("path", {
    fill: colors$1.BlueDark,
    fillRule: "evenodd",
    d: "M13.9 12.25l5.42-5.42a.5.5 0 0 0 0-.71l-.94-.94a.5.5 0 0 0-.71 0l-5.42 5.42-5.42-5.42a.5.5 0 0 0-.71 0l-.94.94a.5.5 0 0 0 0 .71l5.42 5.42-5.42 5.42a.5.5 0 0 0 0 .71l.94.94a.5.5 0 0 0 .71 0l5.42-5.42 5.42 5.42a.5.5 0 0 0 .71 0l.94-.94a.5.5 0 0 0 0-.71l-5.42-5.42z"
  }));
};
var _excluded = ["ref"],
  _excluded2 = ["ref"];
var colors$2 = functions.config.colors.list;
function waitForDomNode(params, callback) {
  new MutationObserver(function () {
    var el = document.getElementById(params.id);
    if (el) {
      callback(el);
    }
  }).observe(params.parent || document, {
    subtree: true,
    childList: true
  });
}
var IconWrapper = styled.span.withConfig({
  displayName: "SelectDropdownOnly__IconWrapper",
  componentId: "sc-1q362us-0"
})(["display:inline-flex;justify-content:center;height:2.4rem;width:2.4rem;"]);
var StyledIconButton = styled(componentsButton.IconButton).withConfig({
  displayName: "SelectDropdownOnly__StyledIconButton",
  componentId: "sc-1q362us-1"
})(["margin:0 .6rem;"]);
var TransparentButton = styled.button.withConfig({
  displayName: "SelectDropdownOnly__TransparentButton",
  componentId: "sc-1q362us-2"
})(["padding:2px;background:transparent;border:none;cursor:pointer;"]);
var PREFIX_CLASS_NAME = 'PrefixSelectDropdown';
var ClearButtonInput = function ClearButtonInput(props) {
  var _props$innerProps = props.innerProps,
    ref = _props$innerProps.ref,
    restInnerProps = _objectWithoutProperties(_props$innerProps, _excluded);
  return /*#__PURE__*/React.createElement(StyledIconButton, _extends({
    icon: /*#__PURE__*/React.createElement(IcnCrossInput, null),
    kind: "secondary",
    size: "sm"
  }, restInnerProps, {
    ref: ref
  }));
};
var ClearButtonValue = function ClearButtonValue(props) {
  var _props$innerProps2 = props.innerProps,
    ref = _props$innerProps2.ref,
    restInnerProps = _objectWithoutProperties(_props$innerProps2, _excluded2);
  return /*#__PURE__*/React.createElement(TransparentButton, _extends({}, restInnerProps, {
    ref: ref
  }), /*#__PURE__*/React.createElement(IcnCrossValue, null));
};
var itemsStyles = {
  option: function option(defaultStyle, state) {
    return _objectSpread2(_objectSpread2({}, defaultStyle), {}, {
      color: colors$2.BlueDark,
      backgroundColor: colors$2.White
    });
  },
  valueContainer: function valueContainer(defaultStyle) {
    return _objectSpread2(_objectSpread2({}, defaultStyle), {}, {
      color: colors$2.BlueDark
    });
  }
};
var IconToRender = function IconToRender(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  switch (props.icon) {
    case 'icn_arrowUp':
      return /*#__PURE__*/React.createElement(IcnArrowUp, {
        color: props.color
      });
    case 'icn_arrowDown':
      return /*#__PURE__*/React.createElement(IcnArrowDown, {
        color: props.color
      });
  }
};
var SelectDropdownOnly = /*#__PURE__*/function (_React$Component) {
  function SelectDropdownOnly() {
    var _this;
    _classCallCheck(this, SelectDropdownOnly);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SelectDropdownOnly, [].concat(args));
    _defineProperty(_this, "componentDidMount", function () {
      var id = _this.props.id;
      if (!id) {
        return;
      }
      _this.setAccessibilityAttributes(id);
    });
    _defineProperty(_this, "setAccessibilityAttributes", function (id) {
      waitForDomNode({
        id: id,
        recursive: true
      }, function (dropdown) {
        var container = dropdown.getElementsByClassName("".concat(PREFIX_CLASS_NAME, "__value-container"));
        var inputs = dropdown.getElementsByTagName('input');
        var elementToTarget = container[0];
        var roleIsSet = elementToTarget.getAttribute('role') === 'listbox';
        if (roleIsSet) {
          return;
        }
        var _iterator = _createForOfIteratorHelper(inputs),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var input = _step.value;
            input.setAttribute('tabindex', '-1');
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        elementToTarget.setAttribute('role', 'listbox');
        elementToTarget.setAttribute('tabindex', '0');
        elementToTarget.setAttribute('id', "listbox-".concat(id));
      });
    });
    _defineProperty(_this, "state", {
      isFocused: false,
      isHovered: false
    });
    _defineProperty(_this, "focusHandler", function () {
      return _this.setState(function (prevState) {
        return {
          isFocused: !prevState.isFocused
        };
      });
    });
    _defineProperty(_this, "getOptionFromValue", function () {
      // First we need to flatten the options array, as it can contain a nested options array
      var flatOptions = [].concat.apply([], _this.props.options.map(function (option) {
        return Array.isArray(option.options) ? option.options : option;
      }));

      // Then we return the selected option full object. This is what is expected by the API of react-select, contrarily to the API exposed by this component.
      if (Array.isArray(_this.props.value) && _this.props.isMulti) {
        // If we accept multiple values, the value prop can be an array
        return flatOptions.filter(function (option) {
          return _this.props.value.includes(option.value);
        });
      } else {
        // Otherwise it's a string or a number
        return flatOptions.find(function (option) {
          return option.value === _this.props.value;
        }) || null;
      }
    });
    _defineProperty(_this, "handleChange", function (selectedOption) {
      if (_this.props.onChange) {
        _this.props.onChange(Array.isArray(selectedOption) ? selectedOption.map(function (option) {
          return option.value;
        }) : selectedOption.value);
      }
    });
    return _this;
  }
  _inherits(SelectDropdownOnly, _React$Component);
  return _createClass(SelectDropdownOnly, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var CustomDropdownIndicator = function CustomDropdownIndicator(props) {
        return Select.components.DropdownIndicator && /*#__PURE__*/React.createElement(Select.components.DropdownIndicator, props, /*#__PURE__*/React.createElement(IconWrapper, null, /*#__PURE__*/React.createElement(IconToRender, {
          icon: props.selectProps.menuIsOpen ? 'icn_arrowUp' : 'icn_arrowDown',
          color: _this2.state.isHovered ? colors$2.BlueDawn : colors$2.BlueSky
        })));
      };
      var hasComponents = this.props.options.reduce(function (acc, option) {
        return acc || _typeof(option.label) === 'object';
      }, false);
      return /*#__PURE__*/React.createElement(SelectInputWrapper, {
        className: this.props.className,
        id: this.props.id,
        error: this.props.error,
        focused: this.state.isFocused,
        isSearchable: !hasComponents && this.props.isSearchable,
        hasComponents: hasComponents,
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({
            isHovered: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            isHovered: false
          });
        },
        isMobile: this.state.isMobile,
        disabled: this.props.disabled,
        prepend: this.props.prepend,
        append: this.props.append,
        margin: this.props.margin
      }, /*#__PURE__*/React.createElement(Select__default, {
        onFocus: this.focusHandler,
        onBlur: this.focusHandler,
        classNamePrefix: PREFIX_CLASS_NAME,
        isSearchable: !hasComponents && this.props.isSearchable,
        name: this.props.name || 'SelectDropdown-states',
        value: typeof this.props.value !== 'undefined' && this.getOptionFromValue(),
        onChange: this.handleChange,
        options: this.props.options,
        placeholder: this.props.placeholder,
        components: {
          Option: function Option(props) {
            return /*#__PURE__*/React.createElement(SelectDropdownOptionWrapper, _extends({}, props, {
              dropdownID: _this2.props.id
            }));
          },
          SingleValue: function SingleValue(props) {
            return /*#__PURE__*/React.createElement(SelectDropdownOption, _extends({}, props, {
              dropdownID: _this2.props.id
            }));
          },
          DropdownIndicator: CustomDropdownIndicator,
          ClearIndicator: ClearButtonInput,
          MultiValueRemove: ClearButtonValue
        },
        menuIsOpen: this.props.menuIsOpen,
        isDisabled: this.props.disabled,
        styles: itemsStyles,
        isMulti: this.props.isMulti
      }));
    }
  }]);
}(React.Component);
SelectDropdownOnly.defaultProps = {
  placeholder: ''
};
var colors$3 = functions.config.colors.list;
var SelectDropdownWrapper = styled.div.withConfig({
  displayName: "SelectDropdownstyles__SelectDropdownWrapper",
  componentId: "sc-e957pj-0"
})(["", " margin:", ";"], function (props) {
  return props.validationSpace && !props.isMobile ? 'margin-right: 3rem;' : null;
}, function (props) {
  return props.margin;
});
var SelectDropdownAndIconWrapper = styled.div.withConfig({
  displayName: "SelectDropdownstyles__SelectDropdownAndIconWrapper",
  componentId: "sc-e957pj-1"
})(["position:relative;display:flex;align-items:center;"]);
var ErrorWrapper = styled.p.withConfig({
  displayName: "SelectDropdownstyles__ErrorWrapper",
  componentId: "sc-e957pj-2"
})(["margin:", ";color:", ";font-size:", ";line-height:", ";"], function (props) {
  return props.theme.type === 'secure' || props.theme.type === 'small' ? '.2rem 0 0' : '.4rem 0 0';
}, colors$3.Tomato, function (props) {
  return props.theme.type === 'secure' || props.theme.type === 'small' ? '1.2rem' : '1.4rem';
}, function (props) {
  return props.theme.type === 'secure' || props.theme.type === 'small' ? '1.6rem' : '1.8rem';
});
var DescriptionWrapper = styled.p.withConfig({
  displayName: "SelectDropdownstyles__DescriptionWrapper",
  componentId: "sc-e957pj-3"
})(["margin:", ";color:", ";font-size:", ";line-height:", ";"], function (props) {
  return props.theme.type === 'secure' || props.theme.type === 'small' ? '.2rem 0 0' : '.4rem 0 0';
}, colors$3.GreyDark, function (props) {
  return props.theme.type === 'secure' || props.theme.type === 'small' ? '1.2rem' : '1.4rem';
}, function (props) {
  return props.theme.type === 'secure' || props.theme.type === 'small' ? '1.6rem' : '1.8rem';
});
var _helpers$resolutions = functions.helpers.resolutions,
  getCurrentResolution = _helpers$resolutions.getCurrentResolution,
  MOBILE = _helpers$resolutions.MOBILE;
var BaseSelectDropdown = /*#__PURE__*/function (_React$Component) {
  function BaseSelectDropdown() {
    var _this;
    _classCallCheck(this, BaseSelectDropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, BaseSelectDropdown, [].concat(args));
    _defineProperty(_this, "state", {
      isMobile: /* istanbul ignore next */
      typeof window !== 'undefined' ? getCurrentResolution() === MOBILE : true
    });
    _defineProperty(_this, "componentDidMount", function () {
      typeof window !== 'undefined' && window.addEventListener('resize', _this.onResizeHandler);
    });
    _defineProperty(_this, "componentWillUnmount", function () {
      typeof window !== 'undefined' && window.removeEventListener('resize', _this.onResizeHandler);
    });
    _defineProperty(_this, "onResizeHandler", function (e) {
      _this.setState({
        isMobile: getCurrentResolution() === MOBILE
      });
    });
    return _this;
  }
  _inherits(BaseSelectDropdown, _React$Component);
  return _createClass(BaseSelectDropdown, [{
    key: "render",
    value: function render() {
      var getUniqueID = function getUniqueID() {
        return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);
      };
      var id = this.props.id || getUniqueID();
      return /*#__PURE__*/React.createElement(SelectDropdownWrapper, {
        margin: this.props.margin,
        isMobile: this.state.isMobile,
        validationSpace: this.props.validationSpace
      }, !this.props.externalLabel && (this.props.hideLabel ? /*#__PURE__*/React.createElement(componentsVisuallyhidden.VisuallyHidden, null, /*#__PURE__*/React.createElement(componentsLabel.Label, {
        htmlFor: id,
        weight: this.props.labelWeight
      }, this.props.label)) : /*#__PURE__*/React.createElement(componentsLabel.Label, {
        htmlFor: id,
        weight: this.props.labelWeight,
        isOptional: this.props.isOptional,
        language: this.props.language
      }, this.props.label)), /*#__PURE__*/React.createElement(SelectDropdownAndIconWrapper, null, /*#__PURE__*/React.createElement(SelectDropdownOnly, {
        isSearchable: this.props.isSearchable,
        placeholder: this.props.placeholder,
        menuIsOpen: this.props.menuIsOpen,
        disabled: this.props.disabled,
        id: id,
        options: this.props.options,
        name: this.props.name,
        error: !!this.props.errorMessage || this.props.error,
        value: this.props.value,
        onChange: this.props.onChange,
        required: !this.props.isOptional,
        prepend: this.props.prepend,
        append: this.props.append,
        isMulti: this.props.isMulti
      })), this.props.description && /*#__PURE__*/React.createElement(DescriptionWrapper, null, this.props.description), this.props.errorMessage && /*#__PURE__*/React.createElement(ErrorWrapper, null, this.props.errorMessage));
    }
  }]);
}(React.Component);
BaseSelectDropdown.defaultProps = {
  options: [],
  isSearchable: false
};
var SelectDropdown = function SelectDropdown(props) {
  return /*#__PURE__*/React.createElement(BaseSelectDropdown, props);
};
SelectDropdown.defaultProps = BaseSelectDropdown.defaultProps;
var SelectDropdownExternalLabel = function SelectDropdownExternalLabel(props) {
  return /*#__PURE__*/React.createElement(BaseSelectDropdown, _extends({
    externalLabel: true,
    id: props.id
  }, props));
};
SelectDropdownExternalLabel.defaultProps = BaseSelectDropdown.defaultProps;
exports.SelectDropdown = SelectDropdown;
exports.SelectDropdownExternalLabel = SelectDropdownExternalLabel;
exports.SelectDropdownOnly = SelectDropdownOnly;